import type { LeadTimeEntry } from '../types';

/**
 * A lead entry belongs to this project when it is tagged to the project's deal,
 * or it has no deal and was logged on the lead that created that deal.
 * Entries tagged to a different deal stay with that deal.
 * Keep in step with functions/src/listProjectTimeEntries.ts leadEntryBelongsToProject.
 */
export function leadEntryBelongsToProject(
  entry: { leadId: string; dealId?: string | null },
  scope: { dealId: string; leadId?: string | null },
): boolean {
  const projectDealId = scope.dealId.trim();
  if (!projectDealId) return false;
  const entryDealId = (entry.dealId || '').trim();
  if (entryDealId) return entryDealId === projectDealId;
  const leadId = (scope.leadId || '').trim();
  return Boolean(leadId) && entry.leadId === leadId;
}

export function selectLeadTimeForProject(
  entries: LeadTimeEntry[],
  scope: { dealId?: string | null; leadId?: string | null },
): LeadTimeEntry[] {
  const dealId = (scope.dealId || '').trim();
  if (!dealId) return [];
  return entries.filter((entry) =>
    leadEntryBelongsToProject(entry, { dealId, leadId: scope.leadId }),
  );
}
